import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Date grouping utilities for schedule
export function groupScheduleItemsByDate<T extends { start_time: string }>(items: T[]) {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const weekEnd = new Date(today);
  weekEnd.setDate(weekEnd.getDate() + 7);

  const groups: {
    today: T[];
    tomorrow: T[];
    thisWeek: T[];
    later: T[];
  } = {
    today: [],
    tomorrow: [],
    thisWeek: [],
    later: [],
  };

  items.forEach((item) => {
    const itemDate = new Date(item.start_time);
    const itemDay = new Date(itemDate.getFullYear(), itemDate.getMonth(), itemDate.getDate());

    if (itemDay.getTime() === today.getTime()) {
      groups.today.push(item);
    } else if (itemDay.getTime() === tomorrow.getTime()) {
      groups.tomorrow.push(item);
    } else if (itemDay < weekEnd) {
      groups.thisWeek.push(item);
    } else {
      groups.later.push(item);
    }
  });

  return groups;
}

export function formatDateHeader(date: Date): string {
  return date.toLocaleDateString("en-US", {
    weekday: "long",
    month: "short",
    day: "numeric",
  });
}
